const requiredProps = [];

const optionalProps = ['id'];

const specificProps = [
    {
        name: 'env',
        type: String,
        required: false,
        default: 'production',
        validator(value) {
            return [
                'sandbox',
                'production',
            ].indexOf(value) !== -1;
        },
    },
    {
        name: 'commit',
        type: Boolean,
        required: false,
        default: true,
    },
    {
        name: 'offer',
        type: Object,
        required: false
    }
];

export default function () {
    const props = {};

    // all required props are type String for now
    requiredProps.forEach(([name, def]) => {
        props[name] = {
            type: String,
            required: true,
            default: (typeof def !== 'undefined')
                ? def
                : undefined,
        };
    });

    // all optional props are type String for now
    optionalProps.forEach(([name, def]) => {
        props[name] = {
            type: String,
            required: false,
            default: (typeof def !== 'undefined')
                ? def
                : undefined,
        };
    });

    // all specific props are declared ahead of time
    specificProps.forEach((prop) => {
        props[prop.name] = {
            type: prop.type,
            required: prop.required,
        };

        if (prop.default !== undefined) {
            props[prop.name].default = prop.default;
        }
    });

    return props;
}



// WEBPACK FOOTER //
// ./src/utils/paypalDefaultProps.js